// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__Ghiq9","body":"styles_body__jB7UO","left":"styles_left__-wHwA"};